import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PartnersBenefits from './PartnersBenefits';
import PartnersCTA from './PartnersCTA';
import PartnersGrid from './PartnersGrid';
import PartnersHero from './PartnersHero';
import { partnersData } from '../../utils/partnersData';
import SEO from '../SEO/SEO';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const PartnersPageLayout: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '').trim();
    if (!hash) return;

    let attempts = 0;
    const maxAttempts = 12;
    const timer = window.setInterval(() => {
      attempts += 1;
      const target = document.getElementById(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.clearInterval(timer);
        return;
      }
      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 120);

    return () => window.clearInterval(timer);
  }, [location.hash]);

  return (
    <main className="pt-[72px] bg-white">
      <SEO
        title={t('partnersSection.seo.title')}
        description={t('partnersSection.seo.description')}
        keywords={t('partnersSection.seo.keywords')}
      />
      <BreadcrumbSchema items={[{ name: t('partnersSection.breadcrumb'), url: '/partners' }]} />
      <PartnersHero />
      <PartnersGrid items={partnersData} />
      <PartnersBenefits />
      <PartnersCTA />
    </main>
  );
};

export default PartnersPageLayout;
